import React, { Component } from "react";
import axios from "axios";
import { Row, Col } from "react-bootstrap";
import { api_base, currency } from '../config';
import '../style/item.scss';

class Items extends Component {
  state = {
    items: [],
    value: 'add'
  };

  componentDidMount() {
    const cart = sessionStorage.getItem("cart");
    let cart_item = [];
    if (cart) {
      cart_item = JSON.parse(cart);
    } else {
      this.setState({ null_item: true });
    }
    let id = "";
    cart_item.forEach((items) => {
      id += items.id + "-";
    });

    if (id !== "") {
      id = id.slice(0, -1);
    }

    axios
      .post(
        api_base + "/menu/multi_items",
        {
          items: id,
        },
        {
          "Content-Type": "application/x-www-form-urlencoded",
        }
      )
      .then((response) => {
        const datas = response.data;
        if (datas.status === true) {
          let it = Object.values(datas.result);
          this.setState({ items: it });
          this.props.addItems(it);
        }
      })
      .catch((response) => {
        this.setState({ items: [] });
      });
  }

  deleteItem = (item, key) => {
    let items = this.state.items;
    items.splice(key, 1);
    this.setState({ items: items });
    this.props.deleteItem(item);
  }
  
  render() {
    let product = this.state.items;
    let i_count = 0;
    let i_total = 0;
    let i_note = '';
    let s_total = 0;
    let cart = this.props.cart_item;

    return (
      <Row>
        {
          product.map((item, key) => {
            cart.forEach((cart_item) => {
              if(item.id === cart_item.id){
                i_count = cart_item.count;
                i_note = cart_item.note;
                return true;
              }
            });
            i_total = (i_count*item.price);
            s_total += i_total;
            return (
              <Col md={12} className="sale-items" key={key}>
                <div className="sale-items-final">
                  <div className="cart-items">
                    <div className="first-box">
                      <img
                        src={item.url}
                        alt={item.title}
                        className="category-logo"
                      />
                      <label>
                        {'{ '}{this.props.round(item.price)}x{i_count}{' }'}
                      </label>
                    </div>
                    <div className="second-box">
                      <h5>{item.title}</h5>
                      <p>{item.description}</p>
                      <label>{this.props.round(i_total)} {currency}</label>
                      <div className="mult">
                        <button onClick={() => this.props.decrement(item.id)} className="minus">-</button>
                        <input type="text" value={i_count} readOnly />
                        <button onClick={() => this.props.increment(item.id)} className="plus">+</button>
                      </div>
                    </div>
                    <div className="remove-from-cart" onClick={() => this.deleteItem(item.id, key)}></div>
                  </div>
                  <div className="sale-items-support">
                    <textarea
                      className=""
                      name={item.id}
                      placeholder="Note/Comments:"
                      value={i_note}
                      onChange={this.props.addNote}
                    />
                  </div>
                </div>
              </Col>
            );
          })
        }
        
        <Col md={12} className="sale-items">
          <div className="sale-items-final order-clear-box">
            <Row className="justify-content-between">
              <Col>
                <div className="cart-clear-div"><div className="cart-clear" onClick={this.props.clear}>Clear</div></div>
              </Col>
              <Col>
                <div  className="cart-total">
                  Total Amount:
                  <br />
                  <strong>{this.props.round(s_total)} {currency}</strong>
                </div>
              </Col>
            </Row>
          </div>
        </Col>
      </Row>
    );
  }
}
export default Items;
